import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import Dropdown from 'components/dropdown/dropdown';
import messages from './messages';

class ProductCategoryFilter extends React.Component {
  constructor(props) {
    super(props);

    const { intl } = props;

    this.state = { 'selectedCategory': props.selectedCategory };

    this.setupHandlers();

    this.options = [
      {
        'description': intl.formatMessage(messages.category_filter_road_label),
        'value': 'road',
        'action': this.onChange
      },
      {
        'description': intl.formatMessage(messages.category_filter_mountain_xc_label),
        'value': 'mtb-xc',
        'action': this.onChange
      },
      {
        'description': intl.formatMessage(messages.category_filter_mountain_trail_label),
        'value': 'mtb-trail',
        'action': this.onChange
      },
      {
        'description': intl.formatMessage(messages.category_filter_triathlon_label),
        'value': 'triathlon',
        'action': this.onChange
      },
      {
        'description': intl.formatMessage(messages.category_filter_cyclocross_label),
        'value': 'cyclocross',
        'action': this.onChange
      },
      {
        'description': intl.formatMessage(messages.category_filter_commute_sport_label),
        'value': 'commute-sport',
        'action': this.onChange
      },
      {
        'description': intl.formatMessage(messages.category_filter_commute_comfort_label),
        'value': 'commute-comfort',
        'action': this.onChange
      },
    ];
  }

  /**
   * Binds any handlers to the correct context
   *
   * @method  setUpHandlers
   */
  setupHandlers() {
    this.onChange = this.handleChange.bind(this);
  }

  /**
   * React Lifecycle Hook
   * Invoked before a mounted component receives new props. If you need to
   * update the state in response to prop changes, you may compare this.props
   * and nextProps and perform state transitions
   *
   * @method  componentWillReceiveProps
   */
  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedCategory !== this.props.selectedCategory) {
      this.setState({ 'selectedCategory': nextProps.selectedCategory });
    }
  }

  /**
   * Handles changes to the category drop down and will alert any callbacks
   * of the state change. Updates internal state when no callback is present
   *
   * @method handleChange
   * @param  {Object} option [The category object that was chosen]
   */
  handleChange(option) {
    const { onCategoryChange } = this.props;

    if (onCategoryChange) {
      onCategoryChange(option.value);
    } else {
      this.setState({ 'selectedCategory': option.value });
    }
  }

  render() {
    const { intl } = this.props;
    const selectedOption = this.options.find(el => el.value === this.state.selectedCategory);

    return (
      <Dropdown
        animate="bottomRight"
        buttonOptions={this.options}
        className="dropdown_body"
        dynamicTrigger
        label={intl.formatMessage(messages.category_filter_label)}
        theme="light"
        triggerTxt={selectedOption.description}
      />
    );
  }
}

ProductCategoryFilter.propTypes = {
  'selectedCategory': PropTypes.string,
  'onCategoryChange': PropTypes.func
};

ProductCategoryFilter.defaultProps = {
  'selectedCategory': 'road'
}

export default injectIntl(ProductCategoryFilter);



// WEBPACK FOOTER //
// ./src/client/pages/product-matches/_product-category-filter.jsx